export type ColorType =
  | "blue"
  | "green"
  | "red"
  | "yellow"
  | "orange"
  | "pink"
  | "purple"
  | "cyan"
  | "teal"
  | "lime"
  | "fuchsia"
  | "black";

export const bgMap = {
  blue: "bg-blue-500/15",
  green: "bg-green-500/15",
  red: "bg-red-500/15",
  yellow: "bg-yellow-500/15",
  orange: "bg-orange-500/15",
  pink: "bg-pink-500/15",
  purple: "bg-purple-500/15",
  cyan: "bg-cyan-500/15",
  teal: "bg-teal-500/15",
  lime: "bg-lime-500/15",
  fuchsia: "bg-fuchsia-500/15",
  black: "bg-black/15",
};

export const pureBgMap = {
  blue: "bg-blue-500",
  green: "bg-green-500",
  red: "bg-red-500",
  yellow: "bg-yellow-500",
  orange: "bg-orange-500",
  pink: "bg-pink-500",
  purple: "bg-purple-500",
  cyan: "bg-cyan-500",
  teal: "bg-teal-500",
  lime: "bg-lime-500",
  fuchsia: "bg-fuchsia-500",
  black: "bg-black",
};

export const colorMap = {
  blue: "text-blue-500",
  green: "text-green-500",
  red: "text-red-500",
  yellow: "text-yellow-500",
  orange: "text-orange-500",
  pink: "text-pink-500",
  purple: "text-purple-500",
  cyan: "text-cyan-500",
  teal: "text-teal-500",
  lime: "text-lime-500",
  fuchsia: "text-fuchsia-500",
  black: "text-black",
};

export const colorHexMap = {
  blue: "#3b82f6",
  green: "#22c55e",
  red: "#ef4444",
  yellow: "#eab308",
  orange: "#f97316",
  pink: "#ec4899",
  purple: "#a855f7",
  cyan: "#06b6d4",
  teal: "#14b8a6",
  lime: "#84cc16",
  fuchsia: "#d946ef",
  black: "#000",
};

export const bgHexMap = {
  blue: "#3b83f620",
  green: "#22c55e20",
  red: "#ef444420",
  yellow: "#eab30820",
  orange: "#f9731620",
  pink: "#ec489920",
  purple: "#a855f720",
  cyan: "#06b6d420",
  teal: "#14b8a620",
  lime: "#84cc1620",
  fuchsia: "#d946ef20",
  black: "#00020",
};

export const borderColorMap = {
  blue: "border-blue-500/25",
  green: "border-green-500/25",
  red: "border-red-500/25",
  yellow: "border-yellow-500/25",
  orange: "border-orange-500/25",
  pink: "border-pink-500/25",
  purple: "border-purple-500/25",
  cyan: "border-cyan-500/25",
  teal: "border-teal-500/25",
  lime: "border-lime-500/25",
  fuchsia: "border-fuchsia-500/25",
  black: "border-black/25",
};
